'use strict';
require('../../modules/es.object.to-string');
require('../../modules/es.iterator.constructor');
require('../../modules/esnext.iterator.join');

var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Iterator', 'join');
